import { rootApi } from "../../api/rootApi";

const productActivityApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getProductExportData: builder.mutation({
            query: (params) => {
                return {
                    method: "GET",
                    url: "/tenant/product-activity/export",
                    headers: {
                        slug: params.tenant_id,
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                    },
                };
            },
        }),
        getProductTimelineExportData: builder.mutation({
            query: (params) => {
                return {
                    method: "GET",
                    url: `/tenant/product-activity/time-period`,
                    headers: {
                        slug: params.tenant_id,
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                    },
                };
            },
        }),
    }),
});

export const {
    useGetProductExportDataMutation,
    useGetProductTimelineExportDataMutation,
} = productActivityApi;
